import * as React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import portalQueryClient from './queryClient';
import portalStore from './portalStore';
import HarnessProviderWrapper from './HarnessProviderWrapper';
import AuthProvider from './AuthProvider';
import { InternationalProvider } from './InternationalProvider';
import { VerificationProvider } from './VerificationProvider';

const Providers: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <QueryClientProvider client={portalQueryClient}>
    <Provider store={portalStore}>
      <AuthProvider>
        <InternationalProvider>
          <VerificationProvider>
            <HarnessProviderWrapper>{children}</HarnessProviderWrapper>
          </VerificationProvider>
        </InternationalProvider>
      </AuthProvider>
    </Provider>
  </QueryClientProvider>
);

export default Providers;
